/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiUserAvailabilityFromJSON(json) {
    return StreemApiUserAvailabilityFromJSONTyped(json, false);
}
export function StreemApiUserAvailabilityFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userSid': !exists(json, 'user_sid') ? undefined : json['user_sid'],
        'availabilityStatus': !exists(json, 'availability_status') ? undefined : json['availability_status'],
        'reservationSid': !exists(json, 'reservation_sid') ? undefined : json['reservation_sid'],
    };
}
export function StreemApiUserAvailabilityToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'user_sid': value.userSid,
        'availability_status': value.availabilityStatus,
        'reservation_sid': value.reservationSid,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiUserAvailabilityAvailabilityStatus;
(function (StreemApiUserAvailabilityAvailabilityStatus) {
    StreemApiUserAvailabilityAvailabilityStatus["AVAILABLE"] = "AVAILABILITY_STATUS_AVAILABLE";
    StreemApiUserAvailabilityAvailabilityStatus["CONFIRMING"] = "AVAILABILITY_STATUS_CONFIRMING";
    StreemApiUserAvailabilityAvailabilityStatus["INVALID"] = "AVAILABILITY_STATUS_INVALID";
    StreemApiUserAvailabilityAvailabilityStatus["INCALL"] = "AVAILABILITY_STATUS_IN_CALL";
    StreemApiUserAvailabilityAvailabilityStatus["NOTAVAILABLE"] = "AVAILABILITY_STATUS_NOT_AVAILABLE";
    StreemApiUserAvailabilityAvailabilityStatus["OFFLINE"] = "AVAILABILITY_STATUS_OFFLINE";
    StreemApiUserAvailabilityAvailabilityStatus["RESERVED"] = "AVAILABILITY_STATUS_RESERVED";
})(StreemApiUserAvailabilityAvailabilityStatus || (StreemApiUserAvailabilityAvailabilityStatus = {}));
//# sourceMappingURL=StreemApiUserAvailability.js.map